"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldDate = exports.ModelMutatorDate = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorDate extends collection_field_1.ModelMutator {
    manual(newValue) {
        this.state.setFieldValue(this.field.id, newValue);
    }
}
exports.ModelMutatorDate = ModelMutatorDate;
class CollectionModelFieldDate extends collection_field_1.CollectionModelField {
    static isDateField(f) {
        return f.schema.type === CollectionModelFieldDate.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorDate(this);
        }
        return this._Mutator;
    }
    get value() {
        return this.stateValue;
    }
    hasValue() {
        const value = this.value;
        if (value == null || value === '') {
            return false;
        }
        return true;
    }
}
exports.CollectionModelFieldDate = CollectionModelFieldDate;
CollectionModelFieldDate.TYPE = core_api_1.IkeFieldType.DATE;
//# sourceMappingURL=date.field.js.map